import { render, staticRenderFns } from "./TheOthers.vue?vue&type=template&id=fe5286f8&scoped=true&"
import script from "./TheOthers.vue?vue&type=script&lang=js&"
export * from "./TheOthers.vue?vue&type=script&lang=js&"
import style0 from "./TheOthers.vue?vue&type=style&index=0&id=fe5286f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe5286f8",
  null
  
)

export default component.exports